import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, switchMap } from 'rxjs/operators';
import { BackendAccountService } from '../../services/backend-account.service';
import { InventoryActionTypes } from '../../actions/account/actions-inventory';
import * as InventoryActions from '../../actions/account/actions-inventory';
import { HeaderAlertService } from '@uxdf/direct-shared-lib';
import * as CoreActions from '@uxdf/direct-shared-lib/src/lib/login/core.actions';
import { of } from 'rxjs';

@Injectable()
export class EffectsInventory {
  getInventory$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(InventoryActionTypes.GetInventory),
      switchMap(() =>
        this.backendAccountService.getInventory().pipe(
          map(data => {
            data.sort((a, b) => {
              if (a.installDate > b.installDate) {
                return -1;
              }
              if (a.installDate < b.installDate) {
                return 1;
              }
              return 0;
            });
            return new InventoryActions.GetInventorySuccess(data);
          }),
          catchError(error => {
            if (error && error.error !== undefined && (error.error.code === 40 || error.error.code === 42)) {
              return of(new CoreActions.DirectUserRoleHasBeenChanged());
            } else {
              this.alert.add({
                type: 'error',
                content: $localize`:effect-inventory.pageSomethingwentwrongHeading:Oops... Something went wrong`
              });
              return of(new InventoryActions.GetInventoryError());
            }
          })
        )
      )
    )
  });

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store<any>,
    private readonly backendAccountService: BackendAccountService,
    private readonly alert: HeaderAlertService
  ) { }
}
